import script from "./PorqueReservar.vue?vue&type=script&setup=true&lang=js"
export * from "./PorqueReservar.vue?vue&type=script&setup=true&lang=js"

import "./PorqueReservar.vue?vue&type=style&index=0&id=3d615c2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d615c2e"]])

export default __exports__